module.exports = __webpack_public_path__ + "static/commuters-app-logo-bf0ac21eca6328355d6a091f65040317.png";